/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Mentions_LoadingInputs */

const en_notes_mentions_loading = /** @type {(inputs: Notes_Mentions_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading people…`)
};

const pt_br2_notes_mentions_loading = /** @type {(inputs: Notes_Mentions_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando pessoas…`)
};

/**
* | output |
* | --- |
* | "Loading people…" |
*
* @param {Notes_Mentions_LoadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_mentions_loading = /** @type {((inputs?: Notes_Mentions_LoadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Mentions_LoadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_mentions_loading(inputs)
	return pt_br2_notes_mentions_loading(inputs)
});